import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55f46475"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uf-select-relation" }
const _hoisted_2 = { class: "uf-select-relation__body" }
const _hoisted_3 = { class: "uf-select-relation__info" }
const _hoisted_4 = { class: "uf-button" }
const _hoisted_5 = { class: "uf-button--footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu")!
  const _component_list_item = _resolveComponent("list-item")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_uf_daterange_picker = _resolveComponent("uf-daterange-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: _ctx.popupShow,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.popupShow) = $event)),
      position: "right",
      style: { height: '100%', width: '100%' },
      onOpen: _ctx.onOpen
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_nav_bar, {
            title: "我发起的审批单",
            "left-text": "返回",
            "left-arrow": "",
            onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.popupShow = false))
          }),
          _createVNode(_component_van_search, {
            modelValue: _ctx.searchValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchValue) = $event)),
            shape: "round",
            placeholder: "编号/摘要搜索",
            onSearch: _ctx.onSearch
          }, null, 8, ["modelValue", "onSearch"]),
          _createVNode(_component_van_dropdown_menu, {
            "active-color": "#1989fa",
            "close-on-click-outside": false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_dropdown_item, {
                modelValue: _ctx.dropdownMenuInfo.state.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dropdownMenuInfo.state.value) = $event)),
                options: _ctx.dropdownMenuInfo.state.option,
                onChange: _ctx.dropdownMenuItemValueChange
              }, null, 8, ["modelValue", "options", "onChange"]),
              _createVNode(_component_van_dropdown_item, {
                modelValue: _ctx.dropdownMenuInfo.temp.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dropdownMenuInfo.temp.value) = $event)),
                options: _ctx.dropdownMenuInfo.temp.option,
                onChange: _ctx.dropdownMenuItemValueChange
              }, null, 8, ["modelValue", "options", "onChange"]),
              _createVNode(_component_van_dropdown_item, {
                title: "发起时间",
                ref: "dropdownMenuItemRef",
                onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dropdownMenuItemToggle(false)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_field, {
                    modelValue: _ctx.formatDropdownMenuDateValue,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formatDropdownMenuDateValue) = $event)),
                    onClick: _ctx.dropdownMenuItemToggle,
                    readonly: "",
                    placeholder: "请选择"
                  }, null, 8, ["modelValue", "onClick"])
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
              return (_openBlock(), _createBlock(_component_list_item, {
                key: item,
                "user-name": item.user_name,
                title: item.name,
                footer: `发起时间：${item.create_date}`,
                code: item.code,
                content: item.name,
                type: item.state,
                "type-name": item.state_name,
                checked: item.checked,
                "onUpdate:checked": ($event: any) => ((item.checked) = $event),
                onOnToggle: ($event: any) => (_ctx.onToggle($event, item)),
                selectable: "",
                class: "item"
              }, null, 8, ["user-name", "title", "footer", "code", "content", "type", "type-name", "checked", "onUpdate:checked", "onOnToggle"]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_van_button, {
                class: "btn",
                block: "",
                color: "#3d6eeb",
                square: "",
                type: "success",
                onClick: _ctx.onConfirm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确认 ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "onOpen"]),
    _createVNode(_component_uf_daterange_picker, {
      type: "date",
      show: _ctx.dropdownMenuInfo.date.show,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dropdownMenuInfo.date.show) = $event)),
      modelValue: _ctx.dropdownMenuInfo.date.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dropdownMenuInfo.date.value) = $event)),
      onConfirm: _ctx.daterangePickerConfirm,
      onClear: _ctx.daterangePickerClear
    }, null, 8, ["show", "modelValue", "onConfirm", "onClear"])
  ]))
}